import ApiService from "@/utils/api.service";

export default {
    save(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            if (params.option.id) {
                ApiService.put("service/" +
                    params.step.services_id +
                    "/step/" +
                    params.step.id +
                    "/block/" +
                    params.field.block_id +
                    "/field/" +
                    params.field.id +
                    "/option/" +
                    params.option.id, params.option)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .finally(() => {
                        context.dispatch("app/setLoading", false, { root: true });
                    });
            } else {
                this.option
                ApiService.post("service/" +
                    params.step.services_id +
                    "/step/" +
                    params.step.id +
                    "/block/" +
                    params.field.block_id +
                    "/field/" +
                    params.field.id +
                    "/option", params.option)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .finally(() => {
                        context.dispatch("app/setLoading", false, { root: true });
                    });
            }

        });
    },
    getAvailableApiValues(context, params) {
        return new Promise(resolve => {
            ApiService.get("service/" + params.step.services_id + "/step/" + params.step.id + "/block/" + params.field.block_id + "/api-available-values").then(({ data }) => {
                resolve(data);
            })
        })
    }

}